const NO_TRACKING_COOKIE = 'rask_no_tracking=1';

export const isTrackingDisabled = () =>
  (typeof window !== 'undefined' && (window as { __RASK_NO_TRACKING__?: boolean } & Window).__RASK_NO_TRACKING__ === true) ||
  (typeof document !== 'undefined' && document.cookie.split('; ').includes(NO_TRACKING_COOKIE));
